import { useEffect } from "react";
import Navigation from "@/components/site/Navigation";
import Footer from "@/components/site/Footer";
import Services from "@/components/site/Services";

export default function ServicesIndex() {
  useEffect(() => {
    document.title = "Services · AGS Services Ireland";
  }, []);

  return (
    <div className="min-h-screen bg-white text-[#0A0A0A] antialiased" data-testid="services-index">
      <Navigation />
      <main className="pt-24">
        <header className="container-ags py-16 md:py-24 border-b border-[#E5EBF2]">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-16 bg-[#2BB6E5]" />
            <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#0E2A57] font-semibold">
              04 — Our Services
            </span>
          </div>
          <h1 className="font-heading font-extrabold text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.035em] text-[#050B14] max-w-4xl">
            Commercial &amp; industrial cleaning, <span className="italic-display font-normal text-[#0E2A57]">delivered nationwide</span>.
          </h1>
          <p className="mt-8 text-lg md:text-xl text-[#475569] leading-relaxed max-w-2xl">
            Same blue vest, same standards, every site. Choose a service to read scope, RAMS approach,
            compliance posture and request a tailored quote.
          </p>
        </header>
        <Services />
      </main>
      <Footer />
    </div>
  );
}
